import React from 'react';
import ProceduresManualModal from './ProceduresManualModal';
import ProceduresManualContext, {ProceduresManualStore} from './ProceduresManualContext';
import ProcedureDeviationDialog from './ProcedureDeviationDialog';

class ProceduresManualMain extends React.Component {

    static contextType = ProceduresManualContext;
    
    constructor(props)
    {
        super(props);
        this.state = {projectToAdd:null};
    }

    render()
    {   
        return (
        <ProceduresManualStore>
            <ProceduresManualModal/>
            <ProcedureDeviationDialog/>
        </ProceduresManualStore>
        )
    }
}

export default ProceduresManualMain;